import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {AuditFilters} from "../model/filters/audit-filters";
import {AuditsResponse} from "../model/responses/audits-response";

@Injectable({
  providedIn: 'root'
})
export class AuditsService {

  private readonly auditsUrl: string;

  constructor(private http: HttpClient) {
    this.auditsUrl = 'catalog/audits';
  }

  public getAudits(offset?: number, limit?: number, filters?: AuditFilters): Observable<AuditsResponse> {
    let url = `${this.auditsUrl}?sortOrder=${filters.getOrder()}&sortField=${filters.sortField}`
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    return this.http.get<AuditsResponse>(url, options);
  }

}
